import ExpandCategoryIcon from "../../icons/ExpandCategoryIcon";

export default function Submenu({ label, icon, buttons, visible = true }) {
	if (!visible) return null;

	return (
		<>
			<button
				className="section-toggle"
				onClick={(e) => {
					const nextDiv = e.currentTarget.nextElementSibling;
					e.currentTarget.classList.toggle("open");
					if (nextDiv) {
						nextDiv.classList.toggle("open");
					}
				}}
			>
				<div>
					{icon}
					{label}
				</div>
				<div className="toggle-icon">
					<ExpandCategoryIcon />
				</div>
			</button>
			<div className="section-content">
				{buttons.map(
					(button, i) =>
						button.visible && (
							<button
								key={i}
								onClick={button.onClick}
								className={button.className || ""}
							>
								<span className="menu-item-label">{button.label}</span>
								{button.endIcon && (
									<span className="menu-item-end-icon">{button.endIcon}</span>
								)}
							</button>
						)
				)}
			</div>
		</>
	);
}
